module.exports = __webpack_public_path__ + "static/media/rewards_program_logo.3f62ee09.svg";